<template>

 <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  x="0px" y="0px" width="28px" height="28px"
	 viewBox="0 0 46 46" style="enable-background:new 0 0 46 46;" xml:space="preserve">

<g>
	<path class="st0" d="M36.2,23.6c-0.9,0.1-3.5-1.5-1.9-3.4c1.5-1.7,2.3-3.8,2.3-6c0-2.1-0.8-4-2.1-5.8c-1.5-2.1,0.6-3.4,1.7-3.3
		c1.9,0.1,4.6,3.6,4.6,9.3S38.1,23.6,36.2,23.6z"/>
	<g>
		<path class="st0" d="M36.2,0c-5.2,0-10,6.1-5.6,11.7c0.3,0.4,0.6,0.9,0.7,1.4h-0.6c-3.5,0-6.4,2.9-6.4,6.4v9.1v6.2v9.9
			c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v-9.8v-6.2v-9.3c0-2.1,1.7-3.9,3.9-3.9h0.6c-0.2,0.5-0.4,0.9-0.8,1.3
			c-4.4,4.9-0.1,11.8,5.7,11.8c5.5,0,9.8-6.3,9.8-14.4C46,6.3,41.7,0,36.2,0z M36.2,26.2c-4.4-0.5-6.4-4.8-3.8-7.6
			c1.1-1.2,1.7-2.8,1.7-4.4c0-1.5-0.5-3-1.5-4.2c-2.9-4.1,0.3-7.3,3.7-7.5c3.9,0,7.2,5.4,7.2,11.8C43.4,20.8,40.1,26.2,36.2,26.2z"
			/>
	</g>
</g>
<g>
	<path class="st0" d="M9.8,23.6c0.9,0.1,3.5-1.5,1.9-3.4c-1.5-1.7-2.3-3.8-2.3-6c0-2.1,0.8-4,2.1-5.8c1.5-2.1-0.6-3.4-1.7-3.3
		c-1.9,0.1-4.6,3.6-4.6,9.3S7.9,23.6,9.8,23.6z"/>
	<g>
		<path class="st0" d="M0,14.4c0,8.1,4.3,14.4,9.8,14.4c5.9,0,10.1-7,5.7-11.8c-0.3-0.4-0.6-0.8-0.8-1.3h0.6c2.1,0,3.9,1.7,3.9,3.9
			v9.3v6.2v9.8c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3v-9.9v-6.2v-9.1c0-3.5-2.9-6.4-6.4-6.4h-0.6c0.2-0.5,0.4-1,0.7-1.4
			C19.8,6.1,15,0,9.8,0C4.3,0,0,6.3,0,14.4z M2.6,14.4C2.6,8,5.9,2.5,9.8,2.5c3.3,0.2,6.6,3.5,3.7,7.5c-1,1.2-1.5,2.6-1.5,4.2
			c0,1.6,0.6,3.1,1.7,4.4c2.5,2.8,0.6,7.1-3.8,7.6C5.9,26.2,2.6,20.8,2.6,14.4z"/>
	</g>
</g>
</svg>

</template>

<script>
    export default {
        name: "BN_svg"
    }
</script>



// WEBPACK FOOTER //
// src/common/components/svg/chapter/BN_svg.vue